// Constants for each input name attribute
const fieldNames = {
  badges: "badges",
  blockchain: "blockchain",
  founderAttributes: "founderAttributes",
  medium: "medium",
  missionOrCause: "missionOrCause",
  doxxed: "doxxed",
  mintStatus: "mintStatus",
  mintDateGte: "mintDateGte",
  mintDateLte: "mintDateLte",
  mintPriceGte: "mintPriceGte",
  mintPriceLte: "mintPriceLte",
  floorPriceGte: "floorPriceGte",
  floorPriceLte: "floorPriceLte",
  collectionSizeGte: "collectionSizeGte",
  collectionSizeLte: "collectionSizeLte",
  roadmapCategories: "roadmapCategories",
  commissions: "acceptsCommissions",
} as const;

export { fieldNames };
